import { mapGetters } from 'vuex';
import mvtCardAgent from '@/common/components/mvtcardagent/mvt-cardagent.vue';
import format from '@/common/utilities/format';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';

export default {
    name: 'searchAds',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: null,
        },
        type: {
            type: Number,
            default: 0,
        },
        index: {
            type: Number,
            default: 0,
        },
        options: {
            type: Object,
            default: {}
        }
    },
    components: {
        mvtCardAgent,
    },
    watch: {
        data(newVal) {
            this.updateData(newVal);
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['geo', 'msp', 'getGeoDisplayText']),
        cardData() {
            return this.data;
        },
        noneMhlUrl() {
            return `${this.glb.appUrl}mortgage/mrc/?title=getpreapproved&fallback=fedratetile`;
        },
        rateDropOptions() {
            return {
                body: `<div class="text-bold">Rates are dropping</div><div>Mortgage rate drops means now is the time to lock in lower rates.</div>`,
                buttonTxt: 'Get pre-approved',
                trigger: 'fedratetile',
                showDisclaimer: false,
                eventLabel: 'Get_Preapproved_RateDrop',
            };
        },
        firstClaimedHome() {
            if (this.glb.claimedHomes && this.glb.claimedHomes.length > 0) {
                return this.glb.claimedHomes[0];
            } else {
                return null;
            }
        },
    },
    data() {
        return {
            title: '',
            subTitle: '',
            linkText: '',
            href: '',
            theme: '',
            customGA: null,
        };
    },
    mounted() {
        this.updateData(this.cardData);
    },
    methods: {
        updateData(data) {
            if (data) {
                if (!data.isAgentcard) {
                    this.title = data.title;
                    this.subTitle = data.subTitle;
                    this.linkText = data.linkText;
                    this.href = data.href;
                    this.theme = 'theme' + data.type;
                    this.customGA = data.gaConf;
                }
            } else {
                this.theme = 'theme' + this.type;
                if (this.type == 0) {
                    this.title = 'What is Your Home Worth?';
                    this.subTitle = 'Stay up-to-date on your home’s value';
                    this.linkText = 'Get an Instant Valuation';
                    this.href = this.glb.appUrl + 'what-is-your-home-worth/';
                } else if (this.type == 1) {
                    const geoText = this.getGeoDisplayText || this.msp.searchInput || '';
                    this.title = 'Looking to Buy?';
                    this.subTitle = 'Get guidance from a top local Real Estate agent in ' + geoText;
                    this.linkText = 'Connect Now';
                } else if (this.type == 2) {
                    this.title = 'Looking for a Mortgage Loan?';
                    this.subTitle = 'Get matched with a loan officer for preapproval';
                    this.linkText = 'Start Now';
                } else if (this.type == 3) {
                    this.title = 'Find an agent';
                    this.subTitle = 'Get matched with a local agent.';
                    this.linkText = 'Connect Now';
                } else {
                    this.title = 'Stay Up to Date';
                    this.subTitle = 'Get instant updates when new homes hit the market';
                    this.linkText = 'Save This Search';
                }
            }
        },
        action(evt) {
            if (this.href) {
                if (this.href.includes(this.glb.appUrl)) {
                    window.location.href = this.href;
                } else {
                    window.open(this.href, '_blank');
                }
            } else if (this.type === 1) {
                this.openHotlead();
            } else if (this.type === 2) {
                this.show3rdPartyForm(evt);
            } else if (this.type === 3) {
                this.showConnectAgentForm();
            } else {
                this.saveSearch();
            }
            if (this.customGA) {
                this.$eventBus.$emit('ga', this.customGA);
            }
        },
        showConnectAgentForm() {
            this.$eventBus.$emit('dialog-center', {
                name: 'contactAgent',
                trigger: 'contactAgent',
                opt: {},
            });
        },
        show3rdPartyForm(evt) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: 'startnow',
                url: 'preapprove',
                trigger: this.$options.name,
                cta: resolveClickCta(this.linkText, evt, 'ADS'),
            });
        },
        openHotlead(agent) {
            const geoText = this.getGeoDisplayText || this.msp.searchInput || '';
            var hotleadOpt = {
                hotleadTitle: `${this.molang('search.common.tourHomes')} ${geoText}`,
                hotleadType: this.glb.isMobile ? 'MovotobrokerageListingMOBILE' : 'MovotobrokerageListing',
                zipcode: this.geo.zipcode || this.msp.firstZipcode,
                propertyData: this.msp.firstProperty,
                showDisclaimer: false,
                hideProfile: true,
                comment: this.molang('search.common.comment', { geoText }),
            };

            if (agent) {
                hotleadOpt.requestAgentId = agent.agentId;
                agent.agentImage = agent.agentImage || this.glb.cdnUrl + 'images/desktop/agent/agent-min.png';
                hotleadOpt.agentData = agent;
                hotleadOpt.hotleadTitle = `Ask ${format.capitalize(agent.firstName)} a Question`;
                hotleadOpt.buttonText = 'Ask a Question';
                hotleadOpt.comment = `Hi, I am interested in asking ${agent.firstName} a question about homes in ${geoText}`;
                hotleadOpt.lite = true;
                this.$eventBus.$emit('dialog-center', {
                    name: 'mvtHotleadForm',
                    trigger: this.$options.name,
                    opt: hotleadOpt,
                });
            } else {
                hotleadOpt.buttonText = this.linkText;
                this.$eventBus.$emit('dialog-center', {
                    name: 'mvtHotleadForm',
                    trigger: this.$options.name,
                    opt: hotleadOpt,
                });
            }
        },
        saveSearch() {
            this.$eventBus.$emit('eventbus-save-search', { trigger: this.$options.name });
        },
    },
};
